import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'

const credentialTypes = ['customer-id', 'token'] as const

export type wlonCredType = (typeof credentialTypes)[number]
export const wlonDocumentTypes = [
  'invoice',
  'proof-of-delivery',
  'signed-bol',
] as const satisfies readonly DocumentType[]

export const wlon: CarrierDef<wlonCredType> = {
  name: 'Accurate Transport',
  scac: 'wlon',
  credentialTypes,
  legacyCredMap: [
    ['customer-id', 'customerCode'],
    ['token', 'token'],
  ],
  engineLayers: [
    'rating',
    'documents',
    'tracking',
    'pickup',
    'profinder',
    'cancel',
  ],
  documentTypes: wlonDocumentTypes,
}
